import {Icon} from '@chakra-ui/react';

export const BookOpenIcon: React.FC<{
  color?: string;
  width?: string;
  height?: string;
}> = ({color = 'blue.100', width = '43', height = '43'}) => {
  return (
    <Icon
      width={width}
      height={height}
      viewBox='0 0 43 43'
      fill={color}
      color={color}
    >
      <path
        opacity='0.4'
        d='M22 16.2502V28.1877C22.1125 28.1877 22.2281 28.1689 22.3375 28.1283L23.5437 27.6971C24.8406 27.2346 26.2031 26.9971 27.5813 26.9971H29.5031C30.3312 26.9971 31.0031 26.3252 31.0031 25.4971V16.4971C31.0031 15.6689 30.3312 14.9971 29.5031 14.9971H27.5813C26.2063 14.9971 24.8406 15.2346 23.5437 15.6971L22 16.2502Z'
        fill='currentColor'
      />
      <path
        d='M20.4563 15.7L22 16.25V28.1875C21.8875 28.1875 21.7719 28.1687 21.6625 28.1281L20.4563 27.6969C19.1625 27.2375 17.7969 27 16.4219 27H14.5C13.6719 27 13 26.3281 13 25.5V16.5C13 15.6719 13.6719 15 14.5 15H16.4219C17.7969 15 19.1625 15.2375 20.4594 15.7H20.4563ZM13.75 28.5H16.4219C17.8844 28.5 19.3344 28.75 20.7094 29.2437L21.9156 29.675C21.9688 29.6938 22.0281 29.6938 22.0844 29.675L23.2906 29.2437C24.6656 28.7531 26.1187 28.5 27.5781 28.5H30.25C30.6656 28.5 31 28.8344 31 29.25C31 29.6656 30.6656 30 30.25 30H27.5781C26.2875 30 25.0094 30.2219 23.7937 30.6562L22.5875 31.0875C22.2062 31.2219 21.7906 31.2219 21.4094 31.0875L20.2063 30.6562C18.9906 30.2219 17.7125 30 16.4219 30H13.75C13.3344 30 13 29.6656 13 29.25C13 28.8344 13.3344 28.5 13.75 28.5Z'
        fill='currentColor'
      />
    </Icon>
  );
};
